import React from 'react';
import { motion } from 'framer-motion';
import { FaInstagram, FaCamera } from 'react-icons/fa';
import './GallerySection.css';

// Instagram images are in public folder
const insta1 = '/Insta page/1 Insta gallery.webp';
const insta2 = '/Insta page/2 Insta gallery.webp';
const insta3 = '/Insta page/3 Insta gallery.webp';
const insta4 = '/Insta page/4 Insta gallery.webp';
const insta5 = '/Insta page/5 Insta gallery.webp';
const insta6 = '/Insta page/6 Insta gallery.webp';

const GallerySection = () => {
  const galleryImages = [insta1, insta2, insta3, insta4, insta5, insta6];

  return (
    <section className="gallery-section" id="gallery">
      <div className="container">
        <div className="home-section-header">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <FaInstagram />
            Instagram Gallery
          </motion.h2>
          <motion.p
            className="gallery-handle"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{ margin: 0 }}
          >
            Follow our creative journey{' '}
            <a
              href="https://www.instagram.com/_handmade.haven_"
              target="_blank"
              rel="noopener noreferrer"
              className="handle-accent"
            >
              @_handmade.haven_
            </a>
          </motion.p>
        </div>
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <img src={image} alt={`Handmade Creation ${index + 1}`} loading="lazy" />
              <div className="gallery-overlay">
                <a
                  href="https://www.instagram.com/_handmade.haven_"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="gallery-cta">
          <motion.a
            href="https://www.instagram.com/_handmade.haven_"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-gallery"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            whileHover={{ scale: 1.05, y: -3 }}
          >
            <FaCamera />
            View Instagram Gallery
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;

